import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  CompaniesSummaryQueryParams,
  CompaniesSummaryResponse,
} from './companiesSummary.types';
import { getCompaniesSummary } from './companiesSummary.api';

const name = 'companiesSummary';

export const fetchCompaniesSummaryAction = createAsyncThunkFromFetch<
  CompaniesSummaryResponse,
  {
    params?: CompaniesSummaryQueryParams;
  }
>(`${name}/fetchCompaniesSummary`, getCompaniesSummary);

export const fetchCompaniesSummaryForExportAction = createAsyncThunkFromFetch<
  CompaniesSummaryResponse,
  {
    params?: CompaniesSummaryQueryParams;
  }
>(`${name}/fetchCompaniesSummaryForExport`, getCompaniesSummary);
